import styled from "styled-components";
import { StyledCell } from "../row/row.styled";

export const StyledHeaderCell = styled(StyledCell)<{
    isFirst?: boolean;
    isLast?: boolean;
}>`
    position: relative;

    opacity: 1;

    border-right: solid 0.5px ${(props) => props.theme.colors.neutral[200]} !important;

    ${(props) =>
        props.isFirst &&
        `
        & > div:first-child > *:first-child {
            display: none;
        }
        & > div:last-child {
            left: 0;
        }
    `}

    ${(props) =>
        props.isLast &&
        `

        border-right: none !important;
        & > div:first-child > *:last-child {
            display: none;
        }
        & > div:last-child {
            right: 0;
        }
    `}

    & > input {
        opacity: ${(props) => (props.isHidden ? 0.25 : 1)};
    }
`;

export const StyledTooltipMenu = styled.div`
    position: absolute;
    z-index: 1;
    bottom: -2.6rem;

    height: 3.2rem;
    width: fit-content;

    background: white;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.4rem;

    border-radius: 0.2rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
`;

export const StyledArrowMenu = styled(StyledTooltipMenu)`
    top: -2.4rem;
    bottom: initial;
`;

export const IconContainer = styled.div<{ isSelected?: boolean }>`
    height: 2.4rem;
    width: 2.4rem;

    border-radius: 0.2rem;
    background: ${(props) => props.theme.colors.neutral[150]};

    display: grid;
    place-items: center;
    cursor: pointer;

    &:hover {
        background: ${(props) => props.theme.colors.primary[200]};
        color: white;
    }

    ${(props) =>
        props.isSelected &&
        `
        background: ${props.theme.colors.primary[400]};
        color: white;
        `}
`;

export const MutedIconContainer = styled(IconContainer)`
    &:hover {
        background: ${(props) => props.theme.colors.neutral[200]};
        color: initial;
    }
`;

export const DangerIconContainer = styled(IconContainer)`
    color: ${(props) => props.theme.colors.danger[300]};
    background: ${(props) => props.theme.colors.danger[100]};

    &:hover {
        color: white;
        background: ${(props) => props.theme.colors.danger[300]};
    }
`;

export const Divider = styled.div`
    height: 2.6rem;
    width: 2px;
    background: ${(props) => props.theme.colors.neutral[300]};
`;
